export default [
  {
    title: 'Consumo Anual (kg)',
    field: 'annual_consumption_kg',
    type: 'numeric'
  },
  {
    title: 'Compra Anual (kg)',
    field: 'annual_purchase_kg',
    type: 'numeric'
  },
  {
    title: 'Ano',
    field: 'year',
    type: 'numeric'
    //type: 'date'
  }
];
